module.exports = __webpack_public_path__ + "img/notebook-active.008b54b.svg";